/* eslint-disable import/no-anonymous-default-export */
import React, { PureComponent } from "react";
import { Redirect, Route, RouteProps } from "react-router-dom";

type Props = {
  component: any
  isLoggedIn: boolean;
  appProps?: object;
} & RouteProps;

export default class extends PureComponent<Props> {
  render() {
    const { component: C, isLoggedIn, appProps, ...routerProps } = this.props;
    return (
      <Route
        {...routerProps}
        render={props => (
          isLoggedIn ? (
            <C {...props} {...appProps} />
          ) : <Redirect to={`/login`} />
        )}
      />
    );
  }
}
